function detailsSlider() {
  new Swiper(".details-slider", {
    slidesPerView: "auto",
  });
}

function initFaq() {
  document.querySelectorAll(".faq-question").forEach(function (e) {
    e.addEventListener("click", function (e) {
      e.preventDefault();
      const t = this.closest(".faq-item"),
        n = t.querySelector(".faq-answer");
      (jQuery(n).slideToggle(300), t.classList.toggle("is-active"));
    });
  });
}

function lovedSlider() {
  new Swiper(".loved-slider", {
    slidesPerView: "auto",
  });
}

function obsessionSlider() {
  new Swiper(".obsession-slider", {
    slidesPerView: "auto",
  });
}

function initProductSubsliders() {
  const e = new Swiper(".product-subslider", {
    spaceBetween: 1,
    slidesPerView: "auto",
    freeMode: !0,
    watchSlidesProgress: !0,
    spaceBetween: 10,
  });
  new Swiper(".product-slider", {
    spaceBetween: 10,
    thumbs: {
      swiper: e,
    },
  });
}

function initProductAccordion() {
  document.querySelectorAll(".product-accordion-btn").forEach(function (e) {
    e.addEventListener("click", function (e) {
      e.preventDefault();
      const t = this.closest(".product-accordion-item"),
        n = t.querySelector(".product-accordion-content");
      (jQuery(n).slideToggle(300), t.classList.toggle("is-active"));
    });
  });
}

function runSlider(el) {
  function start() {
    const firstChild = el.firstElementChild;
    if (!firstChild) return;
    const n = firstChild.getBoundingClientRect().width;
    if (!n) return;
    const duration = n / 80;
    const id = 'marquee-' + Math.random().toString(36).slice(2);
    const style = document.createElement('style');
    style.textContent = '@keyframes ' + id + ' { to { transform: translateX(' + (-n) + 'px); } }';
    document.head.appendChild(style);
    el.style.willChange = 'transform';
    el.style.animation = id + ' ' + duration + 's linear infinite';
  }

  const imgs = el.firstElementChild ? Array.from(el.firstElementChild.querySelectorAll('img')) : [];
  if (!imgs.length) { start(); return; }
  let pending = imgs.filter(img => !img.complete).length;
  if (!pending) { start(); return; }
  imgs.forEach(function(img) {
    if (img.complete) return;
    img.addEventListener('load',  function() { if (--pending === 0) start(); }, { once: true });
    img.addEventListener('error', function() { if (--pending === 0) start(); }, { once: true });
  });
}

function initRunSliders() {
  document.querySelectorAll(".run-line").forEach(runSlider);
}

function initSexySlider() {
  const e = 0.25,
    t = 0.03;
  new Swiper(".sexy-slider", {
    slidesPerView: "auto",
    spaceBetween: 20,
    centeredSlides: !0,
    loop: !0,
  });
  (!(function n() {
    (!(function () {
      const n = document.querySelectorAll(".sexy-img"),
        i = window.innerWidth,
        o = 0.5 * i,
        r = i <= 1023;
      n.forEach((n) => {
        if (r)
          return (
            (n.style.transform = "none"),
            void (n.style.transformOrigin = "center center")
          );
        const i = n.getBoundingClientRect(),
          s = i.x + 0.5 * i.width,
          c = o - s;
        let d = Math.abs(c) * e;
        const l = -c * t;
        ((n.style.transformOrigin = "center top"),
          (n.style.transform = "translateY("
            .concat(d, "px) rotate(")
            .concat(l, "deg)")));
      });
    })(),
      requestAnimationFrame(n));
  })(),
    window.addEventListener("resize", () => {
      if (window.innerWidth <= 768) {
        document.querySelectorAll(".sexy-img").forEach((e) => {
          ((e.style.transform = "none"),
            (e.style.transformOrigin = "center center"));
        });
      }
    }));
}
document.addEventListener("DOMContentLoaded", function () {
  $("#comparison").twentytwenty({
    default_offset_pct: 0.5,
    orientation: "horizontal",
    no_overlay: !0,
    move_slider_on_hover: !1,
    click_to_move: !0,
  });
  initRunSliders();
});
detailsSlider();
initFaq();
lovedSlider();
obsessionSlider();
initProductSubsliders();
initProductAccordion();
initSexySlider();
Fancybox.bind("[data-fancybox]", {});
